module.exports = __webpack_public_path__ + "media/2DP_Baumit_Bauminator-Header_2021-08-09_V03(1Mbps).mp4";